import { lazy } from 'react';

import { Location } from '@cobliteam/common-types';

const FuelCardPage = lazy(() => import('@cobliteam/fuel-card'));

const routes = [
  {
    title: 'Gestão de combustível',
    path: Location.FUEL_CARD,
    component: FuelCardPage,
    accessDeniedDescription: 'ver informações de gestão de combustível',
  },
];

export default routes;
